import React from "react";

// Scss imports
import css from "./StepsProgressBar.module.scss";

interface StepsProgressBarProps {
  onStepProgressBarClickHandler?: Function;
  activeStep: number;
  onStepClickHandler: Function;
}

const StepsProgressBar: React.FC<StepsProgressBarProps> = ({
  activeStep,
  onStepClickHandler
}) => {
  return (
    <div className={css.progressBar}>
      <div
        onClick={() => onStepClickHandler(1)}
        className={`${css.progressStep} ${
          activeStep === 1 ? css.isActive : null
        }`}
      >
        <div className={css.stepCount}></div>
        <div className={css.stepDescription}>Избор типа налога</div>
      </div>
      <div
        onClick={() => onStepClickHandler(2)}
        className={`${css.progressStep} ${
          activeStep === 2 ? css.isActive : null
        }`}
      >
        <div className={css.stepCount}></div>
        <div className={css.stepDescription}>Основни подаци</div>
      </div>
      <div
        onClick={() => onStepClickHandler(3)}
        className={`${css.progressStep} ${
          activeStep === 3 ? css.isActive : null
        }`}
      >
        <div className={css.stepCount}></div>
        <div className={css.stepDescription}>Адреса</div>
      </div>
      <div
        onClick={() => onStepClickHandler(4)}
        className={`${css.progressStep} ${
          activeStep === 4 ? css.isActive : null
        }`}
      >
        <div className={css.stepCount}></div>
        <div className={css.stepDescription}>Контакт подаци</div>
      </div>
      <div
        onClick={() => onStepClickHandler(5)}
        className={`${css.progressStep} ${
          activeStep === 5 ? css.isActive : null
        }`}
      >
        <div className={css.stepCount}></div>
        <div className={css.stepDescription}>Провера података</div>
      </div>
    </div>
  );
};

export default StepsProgressBar;
